import { render, staticRenderFns } from "./OrdersInboundCreate.vue?vue&type=template&id=a6434a2c&scoped=true"
import script from "./OrdersInboundCreate.vue?vue&type=script&lang=js"
export * from "./OrdersInboundCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6434a2c",
  null
  
)

export default component.exports